export const buttonMotion = {
	initial: 'default',
	animate: 'default',
	whileTap: 'tap',
	whileHover: 'hover',
	whileFocus: 'focus',
	variants: {
		default: {
			scale: 1,
		},
		hover: {
			scale: 1,
		},
		focus: (tapPower = 0.9) => ({
			scale: tapPower,
		}),
		tap: (tapPower = 0.9) => ({
			scale: tapPower,
		}),
	},
	transition: {
		duration: 0.25,
	},
};
